import React, { useState } from "react";
import GeneralOverlay from "./Overlay";
import RmsdList from "./Rmsd";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

export default function StackInfoOverlay({ stack }) {
  const maps = stack.elements.filter(e => e.type === "map");

  return (
    <GeneralOverlay>
      <RmsdList maps={maps} />
    </GeneralOverlay>
  );
}
